<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div class="card-smallHeader card-header-action" v-b-toggle="'collapse-'+typePeriode[0]">
        <div class="card-header-actions">
          <span class="when-opened">
            <i class="icon-arrow-down"></i>
          </span>
          <span class="when-closed">
            <i class="icon-arrow-up"></i>
          </span>
        </div>
        <h5 class="d-inline-block">{{ titre }}</h5>
        <b-form-checkbox class="ml-3" :id="'checkbox-'+typePeriode[0]" v-model="periodeOptions[0]['is_not_available']" name="checkbox-not-available" value="true">
          <i class="fa fa-question-circle text-danger" v-b-tooltip.hover.top title="Information non présente ou illisible"></i>
        </b-form-checkbox>
      </div>
      <b-collapse :id="'collapse-'+typePeriode[0]" v-model="isOpened" class="m-3" :class="isOpened ? 'not-collapsed' : 'collapsed'">
        <b-card-body>
          <b-row class="my-1">
            <b-col sm="3">
              <label >Période:</label>
            </b-col>
            <b-col sm="9">
              <div v-for="(periode,key) in periodeOptions" :key="'periode-bs-'+key" class="d-inline-block">
                Du <b-form-input name="date_debut" v-model="periode.date_debut" class="d-inline-block" style="width: 40%" type="date"></b-form-input> au <b-form-input name="date_fin" v-model="periode.date_fin" class="d-inline-block" style="width: 40%" type="date"></b-form-input>
              </div>
              <i class="fa fa-plus clickable text-success " @click="addPeriode()"></i>
            </b-col>
          </b-row>
          <hr>
          <b-row class="my-1 mt-2">
            <b-col sm="3">
              <label >Année:</label>
            </b-col>
            <b-col sm="9">
              <div v-for="(periode,key) in anneeOptions" :key="'annee-bs-'+key" class="d-inline-block">
                De <b-form-input name="input-annee" v-model="periode.annee" class="d-inline-block" style="width: 40%" type="number"></b-form-input></div>
              <i class="fa fa-plus clickable text-success " @click="addAnnee()"></i>
            </b-col>
          </b-row>
          <b-row v-if="libelleTechnique === 'attestation_ressources'" class="mt-2">
            <b-col sm="12">
              <b-form-group
                label-for="attestationRessource"
                :label-cols="6"
                :content-cols="6"
                :horizontal="true">
                <template slot="label"><b>Attestation de ressource :</b></template>
                <b-form-select class="col-sm-12" v-model="attestationRessourceLocal"
                               :options="attestationRessourceOptions">
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="multiType" >
            <b-col></b-col>
            <b-col><b-button variant="success" class="float-right ml-2 mt-2" @click="copyPeriodes"><i class="fa fa-copy"></i> Copier ces périodes</b-button></b-col>
          </b-row>
        </b-card-body>
      </b-collapse>
      <slot></slot>
    </b-card>
  </div>
</template>

<script>
  import {isEmpty} from "@/utils/fileHelper";
  import { formatDateTime } from "@/utils/communHelper";

  export default {
    name: "FormPeriodeTypePj",
    props: ['periodeOptions', 'anneeOptions', 'titre', 'typePeriode', 'multiType', 'periodes', 'libelleTechnique', 'attestationRessource'],
    data() {
      return {
        isEmpty,
        isOpened: true,
        attestationRessourceOptions:['Avec ressources','Sans ressource'],
        attestationRessourceLocal: ''
      }
    },
    watch: {
      attestationRessourceLocal() {
        if (!isEmpty(this.attestationRessourceLocal)) {
          this.$event.emit('changeAttestationREssource', this.attestationRessourceLocal)
        }
      }
    },
    mounted() {
      this.$event.on('toggleCollapse', (value, typesId) => {
        // console.log('value, typesId',value, typesId)
        const intersection = this.typePeriode.filter(el => typesId.includes(el));
        if (intersection.length > 0) {
          this.isOpened = value === 'close' ? false : true;
        }
      });
      this.attestationRessourceLocal = this.attestationRessource
      // console.log(this.periodeOptions, this.anneeOptions, this.titre, this.typePeriode, this.multiType, this.periodes, this.libelleTechnique)
      // this.$watch(
      //   () => { return this.$refs.typeChecked.checked },
      //   (checked) => {
      //     console.log('checked', checked)
      //     if (checked) {
      //       for (var i = 0; i < this.periodeOptions.length; i++) {
      //         this.periodeOptions[i].date_debut = ''
      //         this.periodeOptions[i].date_fin = ''
      //         this.periodeOptions.pop({ id: null, date_debut: '', date_fin: '' });
      //       }
      //       for (var i = 0; i < this.anneeOptions.length; i++) {
      //         this.anneeOptions[i].annee = ''
      //       }
      //     }
      //   })
    },
    created() {
    },
    methods: {
      getFormattedDateTime(textDate) {
        return formatDateTime(textDate, '/');
      },
      handleErrors() {
        this.$store.commit('IS_LOADING', false);
        this.$swal({
          position: 'top',
          type: 'warning',
          title: 'Attention !!',
          text: 'Une erreur système est survenue, si le problème persiste merci de faire un ticket au support DOSI',
          showConfirmButton: false,
          timer: 4000,
        });
      },
      addPeriode() {
        this.periodeOptions.push({id: null, date_debut: '', date_fin: ''});
      },
      addAnnee() {
        this.anneeOptions.push({id: null, annee: ''});
      },
      copyPeriodes() {
        for (let periode of this.periodes) {
          if (periode.periodeOptions[0]['is_not_available'] == null || periode.periodeOptions[0]['is_not_available'] == false) {
            for (var i = 0; i < this.periodeOptions.length; i++) {
              if (isEmpty(periode.periodeOptions[i])) {
                periode.periodeOptions.push({ id: null, date_debut: '', date_fin: '' });
              }
              periode.periodeOptions[i].date_debut = this.periodeOptions[i].date_debut
              periode.periodeOptions[i].date_fin = this.periodeOptions[i].date_fin
            }
            for (var i = 0; i < this.anneeOptions.length; i++) {
              if (isEmpty(periode.anneeOption[i])) {
                periode.anneeOption.push({ id: null, annee: '' });
              }
              periode.anneeOption[i].annee = this.anneeOptions[i].annee
            }
          }
        }
      },
      // onChange(checked) {
      //   if (checked) {
      //     for (var i = 0; i < this.periodeOptions.length; i++) {
      //       this.periodeOptions[i].date_debut = ''
      //       this.periodeOptions[i].date_fin = ''
      //       this.periodeOptions.pop({ id: null, date_debut: '', date_fin: '' });
      //     }
      //     for (var i = 0; i < this.anneeOptions.length; i++) {
      //       this.anneeOptions[i].annee = ''
      //     }
      //   }
      // }
    }
  }
</script>
<style type="text/css">

</style>
